import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL ?? import.meta.env.BASE_URL.replace(/\/$/, '')

export const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  config.headers['X-Tenant-ID'] = 'dakar'
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message || error.message || 'Erreur inconnue'
    return Promise.reject({ status: error?.response?.status, message, data: error?.response?.data })
  }
)

// Activate mock interceptors when VITE_MOCK_API=true (dev only)
if (import.meta.env.VITE_MOCK_API === 'true') {
  import('@/lib/mockApi').then(({ installMockInterceptors }) => {
    installMockInterceptors(apiClient)
    console.log('[MOCK] Mock API mode activated -- requests will return mock data')
  }).catch(() => {
    // Fail silently if mock module cannot be loaded
  })
}

export default apiClient
